export const DUPLICATE_PRODUCT_PACK_TYPE_ERROR_CODE = 'DUPLICATE_PRODUCT_PACKTYPE_COMBINATION';
